import { render, staticRenderFns } from "./TermConditionsComponent.vue?vue&type=template&id=62a620da&scoped=true&"
import script from "./TermConditionsComponent.vue?vue&type=script&lang=js&"
export * from "./TermConditionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./TermConditionsComponent.vue?vue&type=style&index=0&id=62a620da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a620da",
  null
  
)

component.options.__file = "TermConditionsComponent.vue"
export default component.exports